export default "__VITE_ASSET__BRG5$Sb9__"